

export default {
    name: 'MeatPageMainTags',
    props: {
        tags: {
            type: Array,
            required: true,
            default: () => ([])
        },
    }
}
